import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 14 19",
  "content": "<symbol viewBox=\"0 0 14 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow\">\r\n    <path d=\"M6.91942 18.0811L8.33364 16.6668L13.667 11.3335L12.2528 9.91929L7.91854 14.2544L7.91942 0.666843L5.91942 0.666843L5.91854 14.2531L1.58609 9.9193L0.171874 11.3335L6.91942 18.0811Z\" fill=\"#C6C3C4\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol